// @flow

import * as React from 'react';
import styled from 'styled-components';

type Props = {
    actual: number,
    finish: number,
};
type State = {
};

const ProgressBarWrapper = styled.div`
    display: ${props => props.visible ? 'block' : 'none'};
    width: 100%;
    margin: 5px;
    text-align: center;
`;

const Label = styled.div`
    margin: 2px;
    font-weight: 10px;
    white-space: normal;
    color: ${props => props.fail ? 'red' : 'black'};
`;

const ProgressBar = styled.div`
    display: flex;
    flex-direction: row;
    height: 15px;
    width: calc(100% - 2px);
    border: 1px solid #bfbfbf;
    align-items: center;
    justify-content: flex-start;
    border-radius: 2px;
    background-color: #ffffff;
    margin-bottom: 5px;
`;
const Section = styled.div`
    background-color: green;
    width: ${ props => `${props.status}%`};
    height: 100%;
    transition: width 0.2s ease-in-out;
`;

class ProjectGrid extends React.Component<Props, State> {

    render(): React.Node {
        const { progress, visible, label, fail } = this.props;
        const status = Math.round((progress) * 100);
        return (
            <ProgressBarWrapper
                visible={visible}>
                {label
                    ? <Label fail={fail}>{label}</Label>
                    : null
                }
                {status
                    ? <ProgressBar>
                        <Section status={status} />
                    </ProgressBar>
                    : null
                }
            </ProgressBarWrapper>
        )
    }
}

export default ProjectGrid;



// WEBPACK FOOTER //
// ./src/components/ProgressBar.jsx